import {Component, EventEmitter, Inject, Input, Output} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {GetNbErrorsService} from '../../services/get-nb-errors.service';
import {FooterDetails} from '../../../order/models/footer-extra-info';
import {Order} from '../../../order/models/order';
import {RolesService} from '../../services/roles.service';
import {BO_ORDER, BO_ORDERCANCEL_PICKED} from '../../consts';
import {L10N_LOCALE, L10nLocale} from 'angular-l10n';

@Component({
  selector: ' storever-footer-form',
  templateUrl: './footer-form.component.html',
  styleUrls: ['./footer-form.component.scss']
})
export class FooterFormComponent {

  @Input() form: FormGroup;
  @Input() extraInfo: FooterDetails[];
  @Input() disabledSaveBtn: boolean;
  @Input() simpleFooter: boolean;
  @Input() isEdit: boolean;
  @Input() isDelete = false;
  @Input() order: Order;
  @Input() isExchange: boolean;
  @Input() isSiteShippingEdit: boolean;
  @Output() saveOutput: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() resetOutput: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();
  @Output() cancelOutput: EventEmitter<void> = new EventEmitter<void>();
  @Output() cancelOrderOutput: EventEmitter<void> = new EventEmitter<void>();
  @Output() resetOrder:  EventEmitter<FormGroup> = new EventEmitter<FormGroup>();

  constructor(@Inject(L10N_LOCALE) public locale: L10nLocale, private getNbErrors: GetNbErrorsService, private rolesService: RolesService) {  }

  save(renew: boolean): void {
    this.saveOutput.emit(renew);
  }

  countErrors(): number {
    return this.getNbErrors.countErrors(this.form);
  }

  reset(): void {
    this.resetOutput.emit(this.form);
  }
  resetOrders(): void {
  this.resetOrder.emit(this.form);
}
  cancel(): void {
    this.cancelOutput.emit();
  }
  cancelOrder(): void {
   this.cancelOrderOutput.emit();
  }
  get getOrderStatusNumber(): number {
    return this.order ? +this.order.status : null;
  }

  get isRolesBoOrder(): boolean {
    return this.rolesService.isRole(this.salesRole) && this.getOrderStatusNumber < 5;
  }
  get isRolesOrderCancelRole(): boolean {
    return  this.rolesService.isRole(this.orderCancelRole) && this.getOrderStatusNumber < 6;
  }

  get salesRole(): string {
    return BO_ORDER;
  }
  get orderCancelRole(): string {
    return BO_ORDERCANCEL_PICKED;
  }
}
